abstract class LayoutManager {

    itemGrid: JQuery
    visibleItems: number

    constructor(itemContainer: JQuery) {
        this.itemGrid = itemContainer
    }

    onPreUpdate() {}
    
    /**
     * Called when all cached items are layouted but download of new items is still pending
     */
    onMidUpdate() {}
    
    onPostUpdate() {}

    getCustomStyles(wrapper: string): string {
        return null
    }

    abstract addItem(item: JQuery)
    abstract layoutItem(item: JQuery, position: number)
    abstract removeItem(item: JQuery)
}

export default LayoutManager